
const FooterBase = (props) => {

    

    return (
        <>


        <div className="modal fade text-xs-left" id="default" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel1" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 className="modal-title" id="myModalLabel1">Basic Modal</h4>
                    </div>
                    <div className="modal-body">
                        <h5 id="modal-body-h5"></h5>
                        <p id="modal-body-p">

                        </p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn grey btn-outline-secondary" data-dismiss="modal">بستن</button>
                        <a href="#" id="modal-body-a" className="btn btn-outline-primary">مشاهده</a>
                    </div>
                </div>
            </div>
        </div>


        <footer className="footer footer-static footer-light navbar-border" style={{position: 'fixed', left: '0', right: '0', bottom: '0'}} >
            <p className="clearfix text-muted text-sm-center mb-0 px-2">
                طراحی توسط    
                <a href="https://4rk.ir" target="_blank" title="طراحی اپ اندروید | طراحی اپ ios | طراحی وبسایت" style={{marginRight: '5px'}}>
                     گروه برنامه نویسی آرک
                </a>
            </p>
        </footer>


        </>
    );
}

export default FooterBase;
